import * as c from "./icons/basic-shape-diamond.svg.js";
import * as m from "./icons/basic-shape-hexagon.svg.js";
import * as p from "./icons/basic-shape-primary-circle-ellipse-round.svg.js";
import * as f from "./icons/basic-shape-primary-square-rectangle.svg.js";
import * as g from "./icons/basic-shape-shield.svg.js";
import * as l from "./icons/computer-device-desktop-monitor.svg.js";
import * as v from "./icons/computer-device-desktop.svg.js";
import * as h from "./icons/computer-device-laptop.svg.js";
import * as u from "./icons/computer-device-mobile-phone-android-samsung-back.svg.js";
import * as d from "./icons/computer-device-mobile-phone-android-samsung.svg.js";
import * as b from "./icons/computer-device-mobile-phone-iphone-x-back.svg.js";
import * as k from "./icons/computer-device-mobile-phone-iphone-x.svg.js";
import * as y from "./icons/computer-device-mobile-tablet-touch.svg.js";
import * as w from "./icons/computer-device-mobile-tablet.svg.js";
import * as S from "./icons/computer-device-network-ethernet-cat6.svg.js";
import * as D from "./icons/computer-device-network-lan-www.svg.js";
import * as C from "./icons/computer-device-network-wifi-connection.svg.js";
import * as M from "./icons/computer-device-network-wifi-router.svg.js";
import * as P from "./icons/ecology-science-erlenmeyer-flask.svg.js";
import * as E from "./icons/image-flash-lightning.svg.js";
import * as B from "./icons/image-picture-flower.svg.js";
import * as F from "./icons/interface-alert-exclamation-diamond.svg.js";
import * as L from "./icons/interface-alert-exclamation-triangle-warning.svg.js";
import * as x from "./icons/interface-alert-information-circle.svg.js";
import * as A from "./icons/interface-award-crown.svg.js";
import * as T from "./icons/interface-bookmark-tag.svg.js";
import * as I from "./icons/interface-bookmark.svg.js";
import * as H from "./icons/interface-calendar-date-one.svg.js";
import * as q from "./icons/interface-content-book-open-pages.svg.js";
import * as O from "./icons/interface-content-book-page.svg.js";
import * as R from "./icons/interface-content-file.svg.js";
import * as W from "./icons/interface-content-folder.svg.js";
import * as G from "./icons/interface-copy-clipboard.svg.js";
import * as N from "./icons/interface-edit-attachment.svg.js";
import * as j from "./icons/interface-edit-binocular.svg.js";
import * as U from "./icons/interface-edit-magic-wand.svg.js";
import * as X from "./icons/interface-edit-tool-paint-roller.svg.js";
import * as K from "./icons/interface-edit-tool-pencil.svg.js";
import * as z from "./icons/interface-favorite-award.svg.js";
import * as J from "./icons/interface-favorite-flag.svg.js";
import * as Q from "./icons/interface-favorite-heart.svg.js";
import * as V from "./icons/interface-favorite-star.svg.js";
import * as Y from "./icons/interface-favorite-stars-sparkles.svg.js";
import * as Z from "./icons/interface-hierarchy-flowchart.svg.js";
import * as _ from "./icons/interface-home-house.svg.js";
import * as $ from "./icons/interface-hyperlink.svg.js";
import * as ee from "./icons/interface-lighting-brightness.svg.js";
import * as oe from "./icons/interface-lock-closed.svg.js";
import * as re from "./icons/interface-lock-open-unlock.svg.js";
import * as ie from "./icons/interface-login-key.svg.js";
import * as ae from "./icons/interface-search.svg.js";
import * as te from "./icons/interface-setting-cog.svg.js";
import * as ne from "./icons/interface-share-megaphone-bullhorn.svg.js";
import * as se from "./icons/interface-share-rocket.svg.js";
import * as ce from "./icons/interface-share-satellite.svg.js";
import * as me from "./icons/interface-share-space-ship.svg.js";
import * as pe from "./icons/interface-share.svg.js";
import * as fe from "./icons/interface-signal-square.svg.js";
import * as ge from "./icons/interface-time-clock-circle.svg.js";
import * as le from "./icons/interface-time-hour-glass.svg.js";
import * as ve from "./icons/interface-users-multiple.svg.js";
import * as he from "./icons/interface-weather-moon.svg.js";
import * as ue from "./icons/mail-chat-bubble-square.svg.js";
import * as de from "./icons/mail-send-email-paper-airplane.svg.js";
import * as be from "./icons/mail-send-envelope.svg.js";
import * as ke from "./icons/money-cashier-receipt.svg.js";
import * as ye from "./icons/money-currency-dollar-pay.svg.js";
import * as we from "./icons/money-graph-arrow-increase.svg.js";
import * as Se from "./icons/money-graph-bar-chart-increase.svg.js";
import * as De from "./icons/nature-ecology-leaf.svg.js";
import * as Ce from "./icons/phone-telephone.svg.js";
import * as Me from "./icons/programming-bug.svg.js";
import * as Pe from "./icons/programming-cloud.svg.js";
import * as Ee from "./icons/programming-computer-database-server.svg.js";
import * as Be from "./icons/programming-computer-database.svg.js";
import * as Fe from "./icons/programming-module-four-layout.svg.js";
import * as Le from "./icons/programming-module-three.svg.js";
import * as xe from "./icons/programming-module.svg.js";
import * as Ae from "./icons/programming-script-code.svg.js";
import * as Te from "./icons/shopping-cart.svg.js";
import * as Ie from "./icons/shopping-gift-present.svg.js";
import * as He from "./icons/shopping-shipping-box-parcel-package.svg.js";
import * as qe from "./icons/tag-new-circle.svg.js";
import * as Oe from "./icons/travel-map-earth-globe.svg.js";
const Re = /* @__PURE__ */ Object.assign({
  "./icons/basic-shape-diamond.svg": c,
  "./icons/basic-shape-hexagon.svg": m,
  "./icons/basic-shape-primary-circle-ellipse-round.svg": p,
  "./icons/basic-shape-primary-square-rectangle.svg": f,
  "./icons/basic-shape-shield.svg": g,
  "./icons/computer-device-desktop-monitor.svg": l,
  "./icons/computer-device-desktop.svg": v,
  "./icons/computer-device-laptop.svg": h,
  "./icons/computer-device-mobile-phone-android-samsung-back.svg": u,
  "./icons/computer-device-mobile-phone-android-samsung.svg": d,
  "./icons/computer-device-mobile-phone-iphone-x-back.svg": b,
  "./icons/computer-device-mobile-phone-iphone-x.svg": k,
  "./icons/computer-device-mobile-tablet-touch.svg": y,
  "./icons/computer-device-mobile-tablet.svg": w,
  "./icons/computer-device-network-ethernet-cat6.svg": S,
  "./icons/computer-device-network-lan-www.svg": D,
  "./icons/computer-device-network-wifi-connection.svg": C,
  "./icons/computer-device-network-wifi-router.svg": M,
  "./icons/ecology-science-erlenmeyer-flask.svg": P,
  "./icons/image-flash-lightning.svg": E,
  "./icons/image-picture-flower.svg": B,
  "./icons/interface-alert-exclamation-diamond.svg": F,
  "./icons/interface-alert-exclamation-triangle-warning.svg": L,
  "./icons/interface-alert-information-circle.svg": x,
  "./icons/interface-award-crown.svg": A,
  "./icons/interface-bookmark-tag.svg": T,
  "./icons/interface-bookmark.svg": I,
  "./icons/interface-calendar-date-one.svg": H,
  "./icons/interface-content-book-open-pages.svg": q,
  "./icons/interface-content-book-page.svg": O,
  "./icons/interface-content-file.svg": R,
  "./icons/interface-content-folder.svg": W,
  "./icons/interface-copy-clipboard.svg": G,
  "./icons/interface-edit-attachment.svg": N,
  "./icons/interface-edit-binocular.svg": j,
  "./icons/interface-edit-magic-wand.svg": U,
  "./icons/interface-edit-tool-paint-roller.svg": X,
  "./icons/interface-edit-tool-pencil.svg": K,
  "./icons/interface-favorite-award.svg": z,
  "./icons/interface-favorite-flag.svg": J,
  "./icons/interface-favorite-heart.svg": Q,
  "./icons/interface-favorite-star.svg": V,
  "./icons/interface-favorite-stars-sparkles.svg": Y,
  "./icons/interface-hierarchy-flowchart.svg": Z,
  "./icons/interface-home-house.svg": _,
  "./icons/interface-hyperlink.svg": $,
  "./icons/interface-lighting-brightness.svg": ee,
  "./icons/interface-lock-closed.svg": oe,
  "./icons/interface-lock-open-unlock.svg": re,
  "./icons/interface-login-key.svg": ie,
  "./icons/interface-search.svg": ae,
  "./icons/interface-setting-cog.svg": te,
  "./icons/interface-share-megaphone-bullhorn.svg": ne,
  "./icons/interface-share-rocket.svg": se,
  "./icons/interface-share-satellite.svg": ce,
  "./icons/interface-share-space-ship.svg": me,
  "./icons/interface-share.svg": pe,
  "./icons/interface-signal-square.svg": fe,
  "./icons/interface-time-clock-circle.svg": ge,
  "./icons/interface-time-hour-glass.svg": le,
  "./icons/interface-users-multiple.svg": ve,
  "./icons/interface-weather-moon.svg": he,
  "./icons/mail-chat-bubble-square.svg": ue,
  "./icons/mail-send-email-paper-airplane.svg": de,
  "./icons/mail-send-envelope.svg": be,
  "./icons/money-cashier-receipt.svg": ke,
  "./icons/money-currency-dollar-pay.svg": ye,
  "./icons/money-graph-arrow-increase.svg": we,
  "./icons/money-graph-bar-chart-increase.svg": Se,
  "./icons/nature-ecology-leaf.svg": De,
  "./icons/phone-telephone.svg": Ce,
  "./icons/programming-bug.svg": Me,
  "./icons/programming-cloud.svg": Pe,
  "./icons/programming-computer-database-server.svg": Ee,
  "./icons/programming-computer-database.svg": Be,
  "./icons/programming-module-four-layout.svg": Fe,
  "./icons/programming-module-three.svg": Le,
  "./icons/programming-module.svg": xe,
  "./icons/programming-script-code.svg": Ae,
  "./icons/shopping-cart.svg": Te,
  "./icons/shopping-gift-present.svg": Ie,
  "./icons/shopping-shipping-box-parcel-package.svg": He,
  "./icons/tag-new-circle.svg": qe,
  "./icons/travel-map-earth-globe.svg": Oe
});
function We(o) {
  const r = Object.entries(o).map(([e, s]) => {
    const i = e.replace("./icons/", "").replace(".svg", "");
    return {
      icon: {
        // Prefix the src with the group so that the final flat icon map has unique keys
        src: i,
        title: i.replaceAll("-", " "),
        tags: []
      },
      rawData: s
    };
  }), t = r.map((e) => e.icon), n = Object.fromEntries(r.map((e) => [e.icon.src, e.rawData]));
  return {
    iconDefinitionList: t,
    iconDataMap: n
  };
}
const a = We(Re), je = a.iconDefinitionList, Ge = a.iconDataMap, Ue = (o) => Ge[o];
export {
  Ue as getLibraryIcon,
  je as libraryIcons
};
